import Root from './Root';
import { createPressable } from '@gluestack-ui/pressable';
export const Pressable = createPressable({ Root });
